<script setup>
import { ref, watchEffect, onMounted, onBeforeUnmount } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import Overlay from '@/Shared/Overlay'
import Icon from '@/Shared/Icons/Icon'
import IconCagegory from '@/Shared/Icons/IconBrandCategory'

const open = ref(false)
const html = ref()
const props = defineProps({
  categories: Object,
})

const toggleOpen = () => {
  open.value = !open.value
}

defineExpose({ toggleOpen })

const getCurrentCategory = () => {
  const param = location.search
  const category = param ? param.replace('?category=', '') : 'all'
  return category
}

const categoriesWithAll = (() => {
  const category_all = { categoryID: 0, categoryName: 'All', categoryNameJ: 'すべて', categorySlug: 'all', categoryOrder: 0, categoryDisplayed: 2 }
  const categories = JSON.parse(JSON.stringify(props.categories))
  return [category_all, ...categories]
})()

onMounted(() => {
  html.value = document.getElementsByTagName('html')[0]
  watchEffect(() => {
    if (open.value === true) {
      html.value.classList.add('filter-open')
    } else {
      html.value.classList.remove('filter-open')
    }
  })
})
onBeforeUnmount(() => {
  if (typeof window === 'undefined') return
  window.scroll({ top: 0 })
})
</script>

<template>
  <div :class="{ 'overflow-y-scroll pl-[50px]': open }" class="fixed z-40 h-full top-0 right-0 scrollbar-hidden">
    <div class="bg-white flex items-start h-full shadow-[-2px_0px_10px_rgba(0,0,0,0.15)] overflow-x-hidden">
      <!-- tab -->
      <button class="absolute flex items-center rounded-b-[5px] overflow-hidden text-center translate-x-[1px] py-[8px] sm:py-[10px] px-[12px] sm:px-[14px] bg-white rotate-90 top-[100px] sm:top-[150px] origin-top-left shadow-[-2px_0px_10px_rgba(0,0,0,0.15)]" @click="toggleOpen">
        <Icon type="settings" class="w-[10px] h-auto mr-[10px]" />
        <div class="block font-rift font-bold text-[17px] sm:text-[18px] tracking-[0.01em]">CATEOGRY</div>
      </button>

      <!-- contents -->
      <transition name="slide-filter">
        <template v-if="open">
          <div class="relative max-w-[450px] w-[90vw] bg-white flex items-center flex-col overflow-x-hidden h-full">
            <ButtonClose class="absolute z-10 black top-0 right-0 p-[20px] origin-top-right scale-[1.5]" @click="toggleOpen" />

            <div class="absolute h-full w-full top-0 grid place-items-center">
              <div class="w-full px-[8vw] xs:px-[50px]">
                <div class="pt-[30px] pb-[50px]">
                  <div class="font-rift font-bold tracking-[0.01em] text-[60px] xs:text-[64px] sm:text-[68px] md:text-[72px] lg:text-[76px] xl:text-[80px] mb-[0.1em]">CATEGORY</div>
                  <div class="font-bold text-[14px] xs:text-[15px]">カテゴリーで絞り込む</div>
                  <ul class="relative grid grid-cols-3 pt-[8vw] xs:pt-[40px] text-center m-[-2vw] xs:m-[-10px]">
                    <li v-for="category in categoriesWithAll" :key="category.categoryID" :class="category.categorySlug" class="p-[2vw] xs:px-[10px] xs:py-[12px] text-[2.5vw] xs:text-[11px]">
                      <Link :href="`/brands?category=${category.categorySlug}`" preserve-scroll>
                        <div :class="{ '!bg-[#888] !border-[#888]': category.categorySlug === getCurrentCategory() }" class="w-full aspect-square rounded-[15px] border border-[#ccc] mb-[10px] grid place-items-center [&_a]:block [.no-touch_&]:hover:bg-[#888] [.no-touch_&]:hover:border-[#888] [.no-touch_&]:[&_path]:hover:!fill-white [.no-touch_&]:[&_rect]:hover:!fill-white transition">
                          <IconCagegory :type="category.categorySlug" :class="{ active: category.categorySlug === getCurrentCategory() }" />
                        </div>
                        {{ category.categoryNameJ }}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </template>
      </transition>
    </div>
  </div>

  <transition name="fade">
    <Overlay v-if="open" class="z-30" @click="toggleOpen" />
  </transition>
</template>
